import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full py-20 px-6 pt-[30px] pb-[30px]" style={{
    background: 'var(--cream-dark)'
  }} aria-label="El problema" data-id="element-328">
      <div className="max-w-3xl mx-auto" data-id="element-329">
        {/* Section header */}
        <div className="text-center mb-14" data-id="element-330">
          <p className="text-sm font-bold tracking-widest uppercase mb-4" style={{
          color: 'var(--gold-dark)'
        }} data-id="element-331">
            La Verdad Que Nadie Te Dice
          </p>
          <h2 className="text-4xl md:text-5xl font-bold" style={{
          color: 'var(--brown)'
        }} data-id="element-332">
            El problema no eres tú.
          </h2>
        </div>

        <div className="flex flex-col gap-6" data-id="element-333">
          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-334">
            No es que seas mala repostera. No es que los postres sin gluten sean
            imposibles. No es que tengas que resignarte a comer mal el resto de
            tu vida.
          </p>
          <p className="text-lg font-bold" style={{
          color: 'var(--brown)'
        }} data-id="element-335">
            El problema es que{' '}
            <span style={{
            color: 'var(--gold-dark)'
          }} data-id="element-336">
              nadie te enseñó la verdad
            </span>{' '}
            sobre por qué los postres sin gluten fallan.
          </p>

          {/* Key insight box */}
          <div className="rounded-2xl p-8 my-4 text-center" style={{
          background: 'var(--brown)',
          color: 'var(--cream)'
        }} data-id="element-337">
            <p className="text-xl italic leading-relaxed" style={{
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '1.35rem',
            color: 'var(--gold-light)'
          }} data-id="element-338">
              "El gluten, la mantequilla y el azúcar no están en los postres
              solo para dar sabor. Cada uno cumple una función técnica
              específica e insustituible. Cuando los eliminas sin entender esas
              funciones, el resultado es predecible: desastre."
            </p>
          </div>

          {/* Function breakdown */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-4" data-id="element-339">
            <div className="rounded-xl p-6 text-center" style={{
            background: 'var(--cream)',
            border: '1px solid var(--blush)'
          }} data-id="element-340">
              <div className="text-3xl mb-3" data-id="element-341">🌾</div>
              <h3 className="font-bold mb-2" style={{
              color: 'var(--brown)',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-342">
                El Gluten
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: 'var(--brown-light)'
            }} data-id="element-343">
                Crea la red que atrapa el aire y da estructura al postre
              </p>
            </div>
            <div className="rounded-xl p-6 text-center" style={{
            background: 'var(--cream)',
            border: '1px solid var(--sage-light)'
          }} data-id="element-344">
              <div className="text-3xl mb-3" data-id="element-345">🧈</div>
              <h3 className="font-bold mb-2" style={{
              color: 'var(--brown)',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-346">
                La Mantequilla
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: 'var(--brown-light)'
            }} data-id="element-347">
                Transporta los sabores y mantiene la humedad por horas
              </p>
            </div>
            <div className="rounded-xl p-6 text-center" style={{
            background: 'var(--cream)',
            border: '1px solid var(--gold-light)'
          }} data-id="element-348">
              <div className="text-3xl mb-3" data-id="element-349">🍯</div>
              <h3 className="font-bold mb-2" style={{
              color: 'var(--brown)',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-350">
                El Azúcar
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: 'var(--brown-light)'
            }} data-id="element-351">
                Retiene humedad, crea corteza dorada y actúa como conservante
              </p>
            </div>
          </div>

          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-352">
            ¿Qué pasa cuando los eliminas y simplemente pones harina de arroz,
            aceite de girasol y stevia en su lugar?
          </p>

          {/* Failure list */}
          <div className="rounded-2xl p-8" style={{
          background: 'var(--blush-light)'
        }} data-id="element-353">
            <p className="font-bold mb-4" style={{
            color: 'var(--brown)'
          }} data-id="element-354">
              Que obtienes exactamente lo que has estado obteniendo:
            </p>
            <ul className="flex flex-col gap-3" role="list" data-id="element-355">
              {['Un postre seco. Pálido. Sin corteza.', 'Que se endurece en 2 horas.', 'Que sabe a medicina.', 'Y que al día siguiente parece cemento.'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-356">
                  <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                color: 'var(--blush)'
              }} aria-hidden="true" data-id="element-357" />
                  <span style={{
                color: 'var(--brown-light)'
              }} data-id="element-358">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <p className="text-lg leading-relaxed" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-359">
            <strong style={{
            color: 'var(--brown)'
          }} data-id="element-360">
              Y lo peor:
            </strong>{' '}
            los libros de repostería saludable que circulan en internet fueron
            escritos para mercados europeos o norteamericanos. Piden
            ingredientes que no existen en tu supermercado. O que cuestan una
            fortuna. O que hay que importar.
          </p>

          {/* Final statement */}
          <div className="text-center py-6" data-id="element-361">
            <p className="text-2xl font-bold" style={{
            color: 'var(--gold-dark)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-362">
              Eso tiene que terminar hoy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}